/**
 * @hidden
 **/
var _TimeToken = /** @class */ (function () {
    function _TimeToken() {
        this._timeElapsedQueryEnded = false;
    }
    return _TimeToken;
}());
export { _TimeToken };
//# sourceMappingURL=timeToken.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babylonjs/core/Instrumentation/timeToken.js
// module id = null
// module chunks = 